import { Outlet, useParams } from "react-router-dom"

import { ErrorState } from "src/global/ui/error/ErrorState"
import { GraphQLError } from "graphql"
import { LoadingState } from "src/global/ui/LoadingState"
import { NotFound } from "src/global/ui/error/NotFound"
import { graphql } from "src/api/graphql/gql"
import { useQuery } from "@apollo/client"

const DataAssetRoute_Document = graphql(`
  query DataAssetRoute($id: UUID!) {
    dataAsset(id: $id) {
      id
      __typename
      name
    }
  }
`)

export const DataAssetRoute = () => {
  const { assetId } = useParams<{ assetId: string }>()

  const { data, loading, error } = useQuery(DataAssetRoute_Document, {
    variables: { id: assetId || "" },
    skip: !assetId,
  })

  const hasDataAssetNotFoundError = error?.graphQLErrors?.some(
    (err: GraphQLError) => err.message === "Data Asset not found.",
  )

  if (loading) {
    return <LoadingState loading />
  }

  if (hasDataAssetNotFoundError || !data?.dataAsset) {
    return <NotFound />
  }

  if (error) {
    return <ErrorState errorMessage="There was a problem loading the data asset" />
  }

  return <Outlet />
}
